import {
    FailedUploadColumns,
} from 'app/shared-components/BatchActions/components/UploadFeedback/UploadFeedback.types'

import {
    ProductType,
} from 'app/enums/label.enums'
import {
    getErrorColumn,
} from 'app/shared-components/BatchActions/components/UploadFeedback'
import {
    ForecastCreatePreparedData,
} from './ShortTermForecastCsvUpload.types'

const getColumns = (
    l: (key: string) => string,
): FailedUploadColumns<ForecastCreatePreparedData> => {
    return [
        {
            id: 'accountNameLabel',
            mapCellProps: 'accountNameLabel',
            headerProps: {
                children: l('ACCOUNT'),
            },
            width: '150px',
        },
        {
            id: 'productType',
            mapCellProps: 'productType',
            headerProps: {
                children: l('PRODUCT_TYPE'),
            },
            componentName: 'EnumValue',
            allowedValuesEnum: ProductType,
            width: '100px',
        },
        {
            id: 'originAirportLabel',
            mapCellProps: 'originAirportLabel',
            headerProps: {
                children: l('ORIGIN_AIRPORT'),
            },
            width: '100px',
        },
        {
            id: 'destinationAirportLabel',
            mapCellProps: 'destinationAirportLabel',
            headerProps: {
                children: l('DESTINATION_AIRPORT'),
            },
            width: '140px',
        },
        getErrorColumn(undefined, l),
    ]
}

export default getColumns
